import * as PIXI from 'pixi.js'
//import { Graphics } from 'pixi.js';

const NODE_ZIX = 10;
const NODE_BK_COLOR = 0xfefefe
const NODE_BK_ALPHA = 1

const LINKS_ZIX = 3;
const LINKS_WIDTH = 8;
const LINKS_COLOR = 0x808080;
const LINK_NODES_COLOR = 0x808080;
const LINK_NODES_RADIUS = 12;
const BUS_COLOR_BORDER = 0xD91E23;//0x808080;
const BUS_COLOR_FILL = 0xFFDED6;//0xA6B3BD;
const BATT_COLOR_BORDER = 0xD91E23;//0x808080;
const BATT_COLOR_FILL = 0xFFFFFF;//0xA6B3BD;

const TEXT_TITLES_FONTFAMILY = 'Arial';
const TEXT_TITLES_FONTSIZE = 40;
const TEXT_FONTCOLOR = 'black'
const TEXT_TITLES_FONTWEIGHT = 600;
const TEXT_DESC_FONTSIZE = 36;
const TEXT_DESC_FONTWEIGHT = 300;

const KPI_BKCOLOR = '0xffffff'///'0xffffff';
const KPI_BORDERCOLOR = '0x000000';
const KPI_BORDERWIDTH = 0;
const KPI_BKALPHA = 0;
const KPI_ZIX = 20;
const KPI_WINDOW_WIDTH = 530;
const KPI_VALUE_WIDTH = 320;
const KPI_TEXT_MAX_LETTERS = 18;
const KPI_WINDOW_HEIGHT = 160;
const KPI_TEXT_FONTNAME = 'Arial'
const KPI_TEXT_FONTSIZE = 32;
const KPI_TEXT_FONTCOLOR = '#474D52';
const KPI_CAPTION_FONTWEIGHT = 500;
const KPI_VALUES_FONTWEIGHT = 200;
const KPI_TIME_TO_EMPTY = 30000;

const MOREINFO_BTN_DIAMETER = 50;
const MOREINFO_BTN_SYMSIZE = 32;
const MOREINFO_BTN_COLOR = 0x1e1e1e;
const MOREINFO_BTN_SYMCOLOR = 0xfefefe;
const MOREINFO_BTN_SYMTHK = 8;
const BOTTON_ZIX = 15;

 /**
 * @typedef SignalReg
 * @type {object}
 * @property {number} id
 * @property {string} signalName
 * @property {string} assetId
 * @property {string} unit
 * @property {boolean} isKpi
 * @property {number|string|boolean} staticValue
 */

 /**
 * @typedef SignalSample
 * @type {object}
 * @property {number} id
 * @property {string} signalName
 * @property {string} assetId
 * @property {string} unit
 * @property {number} updatedAt
 * @property {number|string|boolean} currentValue
 */

export class KpiWindow extends PIXI.Graphics{
  constructor(xPos, yPos,width=KPI_WINDOW_WIDTH, height=KPI_WINDOW_HEIGHT) {
    super();
    this.lineStyle(KPI_BORDERWIDTH, KPI_BORDERCOLOR);
    this.beginFill(KPI_BKCOLOR, KPI_BKALPHA);
    this.zIndex = KPI_ZIX;
    this.drawRect(0, 0, width, height);
    this.position.set(xPos, yPos);
    this.visible = true;//changed to default visible

    const mask = new PIXI.Graphics();
    // Add the rectangular area to show
    mask.beginFill(0xffffff);
    mask.drawRect(0, 0, width, height);
    mask.endFill();

    // Add container that will hold our masked content
    const maskContainer = new PIXI.Container(); // Set the mask to use our graphics object from above
    maskContainer.mask = mask;        // Add the mask as a child, so that the mask is positioned relative to its parent
    maskContainer.addChild(mask);     // Offset by the window's frame width
    maskContainer.position.set(1,1);  // And add the container to the window!
    this.addChild(maskContainer);

    const textlineHeight = 50;
    const kpiNameStyle = new PIXI.TextStyle({
      fontFamily: KPI_TEXT_FONTNAME,
      fontSize: KPI_TEXT_FONTSIZE,
      fill: KPI_TEXT_FONTCOLOR, //'#D91E23',
      fontWeight: KPI_CAPTION_FONTWEIGHT,
    });
    const kpiValueStyle = new PIXI.TextStyle({
      fontFamily: KPI_TEXT_FONTNAME,
      fontSize: KPI_TEXT_FONTSIZE,
      fontWeight: KPI_VALUES_FONTWEIGHT,
      fill: KPI_TEXT_FONTCOLOR,
    });
    this.sigCaptions = [ //array of text controls for captions
      new PIXI.Text( '', kpiNameStyle),
      new PIXI.Text( '', kpiNameStyle),
      new PIXI.Text( '', kpiNameStyle),
    ]
    this.sigCaptions[0].setTransform(10, 10);
    this.sigCaptions[1].setTransform(10, 10+textlineHeight);
    this.sigCaptions[2].setTransform(10, 10+2*textlineHeight);
    maskContainer.addChild(this.sigCaptions[0]);
    maskContainer.addChild(this.sigCaptions[1]);
    maskContainer.addChild(this.sigCaptions[2]);
    this.sigValues = [ //array of text controls for sig values
      new PIXI.Text( '', kpiValueStyle),
      new PIXI.Text( '', kpiValueStyle),
      new PIXI.Text( '', kpiValueStyle),
    ];
    this.sigValues[0].setTransform(KPI_VALUE_WIDTH, 10);
    this.sigValues[1].setTransform(KPI_VALUE_WIDTH, 10+textlineHeight);
    this.sigValues[2].setTransform(KPI_VALUE_WIDTH, 10+2*textlineHeight);
    maskContainer.addChild(this.sigValues[0]);
    maskContainer.addChild(this.sigValues[1]);
    maskContainer.addChild(this.sigValues[2]);


    /** @type {Map<number, PIXI.Text} */
    this.nodeSignalValObjs = new Map ();

    /**
     * format a signal sample current value for visual printing 
     * @param {SignalSample} signalSample 
     * @returns {string}
     */
    this.formatSigSample = (signalSample) => {
      if(!signalSample.units) return this.formatSigValue(signalSample);
      return `${this.formatSigValue(signalSample)} ${signalSample.units.substring(0,5)}`
    }

    /**
     * format signal values for visual printing
     * @param {SignalSample} signalSample 
     * @returns {string|number}
     */
    this.formatSigValue = (signalSample) => {
      if(signalSample.currentValue==null) return '-'
      if(typeof(signalSample.currentValue)=='string') return signalSample.currentValue.substring(0,30);
      if(typeof(signalSample.currentValue)=='number'){
        if(Math.abs(signalSample.currentValue)>1000) return Math.round(signalSample.currentValue);
        if(Math.abs(signalSample.currentValue)>100) return Math.round(signalSample.currentValue*10)/10;
        return Math.round(signalSample.currentValue*100)/100;
      }
      if(typeof(signalSample.currentValue)=='boolean') return signalSample.currentValue? 'on':'off';
      return '#'
    }

    this.timerLastUpdateMap = new Map();

  }

  clearKpi(signal){

    const timer = this.timerLastUpdateMap.get(signal);
    clearTimeout(timer)
    const txtCtrl = this.nodeSignalValObjs.get(signal);
    txtCtrl.text = this.static? this.staticValue : 'N/A'
    this.timerLastUpdateMap.set(signal,setTimeout(()=>{this.clearKpi(signal)},KPI_TIME_TO_EMPTY));
  }

  /**
   * register signals to the node for future updates
   * @param {SignalReg[]} arrSignals 
   * @returns {void}
   */
  setKpiSignals(arrSignals){
    const sigNameCounts = new Map();
    for(const sProps of arrSignals){ //check signal names to count name collisions
      const n = sigNameCounts.get(sProps.name)||0;
      sigNameCounts.set(sProps.name, n+1);
    }

    let sIndex = 0;
    
    for(const sProps of arrSignals){ //assign controls to signalId & set signal names
      if(sIndex>this.sigCaptions.length-1) break;
      
      this.nodeSignalValObjs.set(sProps.signalId, this.sigValues[sIndex]);
      this.timerLastUpdateMap.set(sProps.signalId,setTimeout(()=>{this.clearKpi(sProps.signalId)},KPI_TIME_TO_EMPTY));

      if(sigNameCounts.get(sProps.name)==1) {
        if(!sProps.label){
          sProps.label='';
        }
        if(sProps.label.length>KPI_TEXT_MAX_LETTERS)       
          this.sigCaptions[sIndex].text = `${sProps.label}`.substring(0,KPI_TEXT_MAX_LETTERS)
        else{
          this.sigCaptions[sIndex].text = `${sProps.label}`
        }
        this.sigValues[sIndex].text = sProps.signalType=='static'? sProps.staticValue : 'N/A'
      }
      else this.sigCaptions[sIndex].text = `${sProps.assetName}.${sProps.label}`.substring(0,KPI_TEXT_MAX_LETTERS);
      if(sProps.signalType=='static') {
        this.static=true
        this.staticValue=sProps.staticValue
      }else{
        this.static=false
      }
      sIndex+=1;
      
    }
    for(sIndex;sIndex<3;sIndex++){ //erase text of unused controls
      this.sigCaptions[sIndex].text ='';
      this.sigValues[sIndex].text = '';
    }
  }
  
  /**
     * updates kpi values in graphic controls for an array of signal samples 
     * @param {SignalSample[]} signalValues
     */
  updateKpiValues(signalValues) {
    if(!signalValues.length) return ;
    for(const sig of signalValues){
      const txtCtrl = this.nodeSignalValObjs.get(sig.signalId);
      if(txtCtrl){
        // Reset timer
        const timer = this.timerLastUpdateMap.get(sig.signalId);
        clearTimeout(timer)
        this.timerLastUpdateMap.set(sig.signalId,setTimeout(()=>{this.clearKpi(sig.signalId)},KPI_TIME_TO_EMPTY));

        let sigAux={...sig}
        let value = parseFloat(sigAux.currentValue*sigAux.GraphScale)
        if(!isNaN(value))
          sigAux.currentValue=value
        
        txtCtrl.text = this.formatSigSample(sigAux)
      }
    }
  }
}








/**
 * Creates and return a graphic element with standard line attributes
 * @param {PointCoord[]} linePointsArr 
 * @returns {PIXI.Graphics}
 */
export const getLinkLine = (linePointsArr) => {
  if(!linePointsArr.length) return ;
  const line = new PIXI.Graphics();
  line.zIndex = LINKS_ZIX; 
  let origin = true;
  for(const [x, y, ] of linePointsArr){
    if(origin){
      line.lineStyle(LINKS_WIDTH, LINKS_COLOR);
      line.moveTo(x, y);
      origin=false;
    }
    else line.lineTo(x, y);
  }
  for(const [x, y, drawNode] of linePointsArr){
    if(drawNode){
      line.lineStyle(0); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
      line.beginFill(LINK_NODES_COLOR, 1);
      line.drawCircle(x, y, LINK_NODES_RADIUS);
      line.endFill();
      line.lineStyle(LINKS_WIDTH, LINKS_COLOR);
    }
  }
  return line;
}
export const getLine = (linePointsArr,lineWidth,lineColor) => {
  if(!linePointsArr.length) return ;
  const line = new PIXI.Graphics();
  line.zIndex = LINKS_ZIX; 
  let origin = true;
  for(const [x, y, ] of linePointsArr){
    if(origin){
      line.lineStyle(lineWidth, lineColor);
      line.moveTo(x, y);
      origin=false;
    }
    else line.lineTo(x, y);
  }
  for(const [x, y, drawNode] of linePointsArr){
    if(drawNode){
      line.lineStyle(0); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
      line.beginFill(LINK_NODES_COLOR, 1);
      line.drawCircle(x, y, LINK_NODES_RADIUS);
      line.endFill();
      line.lineStyle(lineWidth, lineColor);
    }
  }
  return line;
}


export const getLinkLineBus = (xCoord, yCoord,height,width,open,zind,interactive_) => {
  
  const bus = new PIXI.Graphics();
  let interactive = interactive_ || false;
  
  bus.lineStyle(4,BUS_COLOR_BORDER); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
  bus.beginFill(BUS_COLOR_FILL);
  bus.drawRect(xCoord, yCoord, width, height);

  if (open=='bottom'){
    bus.lineStyle(4,BUS_COLOR_FILL); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
    bus.beginFill(BUS_COLOR_FILL);
    bus.drawRect(xCoord+4, yCoord+height, width-8,1);
  }else if(open=='top'){
    bus.lineStyle(4,BUS_COLOR_FILL); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
    bus.beginFill(BUS_COLOR_FILL);
    bus.drawRect(xCoord+4, yCoord, width-8,1);
  }else if(open=='left'){
    bus.lineStyle(4,BUS_COLOR_FILL); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
    bus.beginFill(BUS_COLOR_FILL);
    bus.drawRect(xCoord, yCoord+4,1,height-8);
  }else if(open=='rigth'){
    bus.lineStyle(4,BUS_COLOR_FILL); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
    bus.beginFill(BUS_COLOR_FILL);
    bus.drawRect(xCoord+width, yCoord+4, 1,height-8);
  }
  bus.endFill();

  bus.zIndex = zind || 2;
  bus.interactive=interactive;
  bus.buttonMode=interactive;
  return bus;
}


/**
 * creates a localized white circle as a background for a node sprite, 
 * check NODE_BK_COLOR and NODE_BK_ALPHA to set color and transparency
 * @param {integer} xCoord - superior left x-axis coordinate
 * @param {integer} yCoord - superior left y-axis coordinate
 * @param {integer} diameter - circle diameter
 * @returns {PIXI.Graphics}
 */
export const getNodeBackground = (xCoord, yCoord, diameter) => {
  const background = new PIXI.Graphics();
  const radius = parseInt(diameter/2);
  background.lineStyle(0); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
  background.beginFill(NODE_BK_COLOR, NODE_BK_ALPHA);
  background.drawCircle(xCoord+radius, yCoord+radius, radius);
  background.endFill();
  background.zIndex = NODE_ZIX-1;
  return background
}


/**
 * create a pixi object with default properties for description text
 * @param {string} descText - default description text 
 * @param {number} xPos - x coords in pixels
 * @param {number} yPos - y coords in pixels
 * @returns {PIXI.Text}
 */
 export const getNodeDescription = (descText, xPos, yPos, width=600) => {
  const textStyle = new PIXI.TextStyle({
    fontFamily: TEXT_TITLES_FONTFAMILY,
    fontSize: TEXT_DESC_FONTSIZE,
    fill: TEXT_FONTCOLOR,
    fontWeight: TEXT_DESC_FONTWEIGHT,
    lineJoin: 'round',
    wordWrap: true,
    wordWrapWidth: width,
  });
  const textObj = new PIXI.Text(descText, textStyle);
  textObj.setTransform(xPos, yPos);
  return textObj;
}

/**
 * creates a more info graphic button with no transparency
 * @param {integer} xCoord - superior left x-axis coordinate
 * @param {integer} yCoord - superior left y-axis coordinate
 * @returns {PIXI.Graphics}
 */
export const getNodeMoreInfoBtn = (xCoord, yCoord) => {
  const button = new PIXI.Graphics();
  const radius = parseInt(MOREINFO_BTN_DIAMETER/2);
  button.lineStyle(0); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
  button.beginFill(MOREINFO_BTN_COLOR, 1);
  button.drawCircle(xCoord+radius, yCoord+radius, radius);
  button.lineStyle(MOREINFO_BTN_SYMTHK, MOREINFO_BTN_SYMCOLOR);
  const symBorder = (MOREINFO_BTN_DIAMETER-MOREINFO_BTN_SYMSIZE)/2;
  //draw + symbol
  button.moveTo(xCoord+radius, yCoord+symBorder);
  button.lineTo(xCoord+radius, yCoord+symBorder+MOREINFO_BTN_SYMSIZE);
  button.moveTo(xCoord+symBorder, yCoord+radius);
  button.lineTo(xCoord+symBorder+MOREINFO_BTN_SYMSIZE, yCoord+radius);
  button.endFill();
  button.zIndex = BOTTON_ZIX;
  button.interactive=true;
  button.buttonMode=true;
  return button
}


export const getNodeCircleAnimation = (xCoord, yCoord, diameter,animationfn) => {
  const circle = new PIXI.Graphics();
  const radius = parseInt(diameter/2);
  
  circle.lineStyle(10, '0x000000',0);
  circle.drawCircle(radius,radius,radius)
  circle.lineStyle(5, '0xf44336');
  circle.arc(radius,radius,radius, 0, 0);
  circle.endFill();
  circle.zIndex = 1000;
  circle.x=xCoord;
  circle.y=yCoord;

  /*circle.height=130;
  circle.width=130;*/

  circle.animation = animationfn;
  return circle;
}




/**
 * creates a node image reading from the (assets/objects) image repository
 * defaults filename to .png 
 * @param {string} nodeImageName - image filename without extension 
 * @param {number} xCoord - superior left x-axis coordinate
 * @param {number} yCoord - superior left y-axis coordinate
 * @param {number} height - node sprite height (px)
 * @param {number} width - node sprite width (px)
 * @returns {PIXI.Graphics}
 */
 export const getNodeSprite = (nodeImageName, xCoord, yCoord, height, width, interactive_) => {

  const nodeSprite = new PIXI.Sprite(nodeImageName.texture);
  const interactive = interactive_ || false;
  nodeSprite.width = height;
  nodeSprite.height = width;
  nodeSprite.x = xCoord;
  nodeSprite.y = yCoord;
  nodeSprite.zIndex = NODE_ZIX;

  nodeSprite.interactive=interactive;
  nodeSprite.buttonMode=interactive;

  return nodeSprite;
}


/**
 * create a pixi object with default properties for title
 * @param {string} title - default text title for object
 * @param {number} xPos - x coords in pixels
 * @param {number} yPos - y coords in pixels
 * @returns {PIXI.Text}
 */
export const getNodeTitle = (titleText, xPos, yPos,anchor=0.5) => {
  const titleStyle = new PIXI.TextStyle({
    fontFamily: TEXT_TITLES_FONTFAMILY,
    fontSize: TEXT_TITLES_FONTSIZE,
    fill: TEXT_FONTCOLOR,
    fontWeight: TEXT_TITLES_FONTWEIGHT,
    lineJoin: 'round',
  });
  const title = new PIXI.Text(titleText, titleStyle);
  title.anchor.x=anchor
  title.setTransform(xPos, yPos);
  
  return title;
}



export const getLinkAnimation = (linePointsArr,animationfn) => {
  if(!linePointsArr.length) return ;
  const num_points=3;
  const separationX=50;
  
  const animation = new PIXI.Graphics();
  animation.zIndex = LINKS_ZIX; 

  animation.beginFill(LINKS_COLOR);
 
  
  let initsX=linePointsArr[0][0];
  let initsY=linePointsArr[0][1];
  for (let i=0; i<num_points; i++){
    animation.drawCircle(initsX, initsY, 10);
    initsX+=separationX;
  }
  animation.endFill();

 /* const  animation = PIXI.Sprite.from(require(`C:/Users/developer/Downloads/pacman.png`));
  animation.x=linePointsArr[0][0]+300;
  animation.y=linePointsArr[0][1]+300;
  animation.width = 20;
  animation.height = 20;*/
  animation.x=linePointsArr[0][0];
  animation.y=linePointsArr[0][1];
  animation.points = linePointsArr;
  animation.animation = animationfn;

  return animation;
}

export const getContactor = (xCoord, yCoord,interactive=false) => {
  const square = new PIXI.Graphics();
  square.zIndex = LINKS_ZIX; 

  square.lineStyle(4,0x808080); // Línea gris (0x808080) de 2 píxeles de grosor
  square.beginFill(0xffffff);   // Fondo blanco (0xffffff)
  square.drawRect(xCoord,yCoord, 75, 75); // Dibujar un cuadrado en (100, 100) con tamaño 50x50
  square.endFill();

  square.zIndex = LINKS_ZIX+1; 

  square.lineStyle(LINKS_WIDTH, LINKS_COLOR)
    .moveTo(xCoord,yCoord+46)
    .lineTo(xCoord+15,yCoord+46)
    .moveTo(xCoord+60,yCoord+46)
    .lineTo(xCoord+75,yCoord+46)

  square.lineStyle(LINKS_WIDTH, LINKS_COLOR)
    .lineStyle(0) // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
    .beginFill(0x808080, 1)
    .drawCircle(xCoord+60,yCoord+46, 8)
    .endFill();

  square.addChild(new PIXI.Graphics())

  // question mark
  const question_icon = new PIXI.Sprite.from(require(`../assets/objects/unknown.png`));
  question_icon.width = 35;
  question_icon.height = 55;
  question_icon.x=xCoord+20;
  question_icon.y=yCoord+10;
  square.addChild(question_icon)
  
  square.interactive=interactive ;
  square.animation = (values)=>{
    let valueSt= parseInt(values[0])
    switch(valueSt){
      case 32768:
      case 4864:
      case 5376:
      case 5120:
      case 4608:
      case 5632:
      case 21760:
        square.children[1]?.destroy()
        square.children[0].clear()
          .lineStyle(8, 0xD91E23)
          .moveTo(xCoord+15,yCoord+46)
          .lineTo(xCoord+50,yCoord+20)
          .lineStyle(0) // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
          .beginFill(0x808080, 1)
          .drawCircle(xCoord+60,yCoord+46, 8)
          .endFill();
        break;
      case 0:
      case 37120:
      case 33024:
      case 33280:
        square.children[1]?.destroy() 
        square.children[0].clear() 
          .lineStyle(8, 0xD91E23)
          .moveTo(xCoord+15,yCoord+46)
          .lineTo(xCoord+60,yCoord+46)
          .lineStyle(0) // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
          .beginFill(0x808080, 1)
          .drawCircle(xCoord+60,yCoord+46, 8)
          .endFill();
        break;
    }
  };

  return square;
}


/// STATUS LED

export const getStatusLed = (xCoord, yCoord) => {
  const circle = new PIXI.Graphics();
  circle.beginFill(0xbbbbbb ); 
  circle.drawCircle(0, 0, 15); 
  circle.endFill();

  circle.x = xCoord;
  circle.y = yCoord;

  circle.animation = (values) =>{
    let valueSt= parseInt(values[0])
    const colorStateON = 0x00FF00
    const colorStateOFF = 0xFF0000
    switch(valueSt){
      case 1:
      case 32768:
      case 4864:
      case 5376:
      case 5120:
      case 4608:
      case 5632:
      case 21760:
        circle.clear();
        circle.beginFill(colorStateOFF); // Relleno rojo (color hexadecimal)
        circle.drawCircle(0, 0, 15); // Dibujar círculo (posición x, y y radio)
        circle.endFill()
        break;
      case 0:
      case 37120:
      case 33024:
      case 33280:
        circle.clear();
        circle.beginFill(colorStateON); // Relleno rojo (color hexadecimal)
        circle.drawCircle(0, 0, 15); // Dibujar círculo (posición x, y y radio)
        circle.endFill()
        break;
    }
  }
  return circle
}

export const getAlarm = (xCoord, yCoord) => {
  const alarm = new PIXI.Sprite.from(require(`../assets/objects/alert.svg`));

  alarm.width = 0
  alarm.height = 0;
  alarm.x = xCoord;
  alarm.y = yCoord;
  alarm.zIndex = NODE_ZIX;

  alarm.animation = (value) =>{
    switch(value[0]){
      case 0:
        alarm.width = 0
        alarm.height = 0
        break;
      case 1:
        alarm.width = 55
        alarm.height = 55
        break;
    }
  }

  return alarm
}

export const getCGM = (xCoord, yCoord,interactive=false) => {

  const square = new PIXI.Graphics();
  square.zIndex = LINKS_ZIX+1; 

  square.lineStyle(4,0x808080); // Línea gris (0x808080) de 2 píxeles de grosor
  square.beginFill(0xffffff);   // Fondo blanco (0xffffff)
  square.drawRect(xCoord,yCoord, 75, 75); // Dibujar un cuadrado en (100, 100) con tamaño 50x50
  square.endFill();

  square.interactive=interactive ;

  /*for(const [x, y, drawNode] of linePointsArr){
    if(drawNode){
      line.lineStyle(0); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
      line.beginFill(LINK_NODES_COLOR, 1);
      line.drawCircle(x, y, LINK_NODES_RADIUS);
      line.endFill();
      line.lineStyle(lineWidth, lineColor);
    }
  }*/
  return square;
}

export const getCBT = (xCoord, yCoord,interactive=false) => {
  const square = new PIXI.Graphics();
  square.zIndex = LINKS_ZIX; 

  square.lineStyle(4,0x808080); // Línea gris (0x808080) de 2 píxeles de grosor
  square.beginFill(0xffffff);   // Fondo blanco (0xffffff)
  square.drawRect(xCoord,yCoord, 75, 75); // Dibujar un cuadrado en (100, 100) con tamaño 50x50
  square.endFill();

  square.zIndex = LINKS_ZIX+1; 

  square.lineStyle(LINKS_WIDTH, LINKS_COLOR)
    .moveTo(xCoord,yCoord+46)
    .lineTo(xCoord+15,yCoord+46)
    .moveTo(xCoord+60,yCoord+46)
    .lineTo(xCoord+75,yCoord+46)

  square.lineStyle(LINKS_WIDTH, LINKS_COLOR)
    .lineStyle(0) // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
    .beginFill(0x808080, 1)
    .drawCircle(xCoord+60,yCoord+46, 8)
    .endFill();

  square.addChild(new PIXI.Graphics())

  // question mark
  const question_icon = new PIXI.Sprite.from(require(`../assets/objects/unknown.png`));
  question_icon.width = 35;
  question_icon.height = 55;
  question_icon.x=xCoord+20;
  question_icon.y=yCoord+10;
  square.addChild(question_icon)

  square.interactive=interactive ;
  
  square.animation=(values) =>{
    let valueSt= parseInt(values[0])
    switch(valueSt){
      case 0:
        square.children[1]?.destroy()
        square.children[0].clear()
          .lineStyle(8, 0xD91E23)
          .moveTo(xCoord+15,yCoord+46)
          .lineTo(xCoord+50,yCoord+20)
          .lineStyle(0) // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
          .beginFill(0x808080, 1)
          .drawCircle(xCoord+60,yCoord+46, 8)
          .endFill();
        break;
      case 1:
        square.children[1]?.destroy() 
        square.children[0].clear() 
          .lineStyle(8, 0xD91E23)
          .moveTo(xCoord+15,yCoord+46)
          .lineTo(xCoord+60,yCoord+46)
          .lineStyle(0) // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
          .beginFill(0x808080, 1)
          .drawCircle(xCoord+60,yCoord+46, 8)
          .endFill();
        break;
    }
  }
  return square;
}


///////// BATTERY
/**
 * creates a square node
 * @param {string} nodeImageName - image filename without extension 
 * @param {number} xCoord - superior left x-axis coordinate
 * @param {number} yCoord - superior left y-axis coordinate
 * @param {number} height - node sprite height (px)
 * @param {number} width - node sprite width (px)
 * @returns {PIXI.Graphics}
 */
export const getNodeSprite_batt = (xCoord,yCoord,interactive_) => {
  const nodeSprite =  new PIXI.Graphics();
  const interactive = interactive_ || false;

  const width = 110;
  const height = 80;
  const space_h = 100;
  const space_v = 10;

  // modules --------------
  nodeSprite.lineStyle(4,BATT_COLOR_BORDER); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
  nodeSprite.beginFill(BATT_COLOR_FILL);
  nodeSprite.drawRect(xCoord, yCoord, width, height);
  nodeSprite.drawRect(xCoord+width+space_h, yCoord, width, height);
  nodeSprite.drawRect(xCoord, yCoord+height+space_v, width, height);
  nodeSprite.drawRect(xCoord+width+space_h, yCoord+height+space_v, width, height);
  nodeSprite.endFill();

  // strings ----------------
  nodeSprite.lineStyle(3,BATT_COLOR_BORDER,0.5); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
  nodeSprite.drawRect(xCoord-30, yCoord-50, width+60, height*2+space_v+70);
  nodeSprite.drawRect(xCoord+width+space_h-30, yCoord-50, width+60, height*2+space_v+70);
  


  // links ----------------------
  nodeSprite.lineStyle(LINKS_WIDTH, BATT_COLOR_BORDER);
  
  // top links
  nodeSprite.moveTo(xCoord+width/2,yCoord);
  nodeSprite.lineTo(xCoord+width/2,yCoord-60);

  nodeSprite.moveTo(xCoord+width/2,yCoord-90);
  nodeSprite.lineTo(xCoord+width/2,yCoord-110);
  nodeSprite.lineTo(xCoord+width+space_h/2,yCoord-110);
  
  nodeSprite.moveTo(xCoord+width*3/2+space_h,yCoord);
  nodeSprite.lineTo(xCoord+width*3/2+space_h,yCoord-60);

  nodeSprite.moveTo(xCoord+width*3/2+space_h,yCoord-90);
  nodeSprite.lineTo(xCoord+width*3/2+space_h,yCoord-110);
  nodeSprite.lineTo(xCoord+width+space_h/2,yCoord-110);
  nodeSprite.lineTo(xCoord+width+space_h/2,yCoord-130);
  nodeSprite.lineTo(xCoord+450,yCoord-130);
  nodeSprite.moveTo(xCoord+480,yCoord-130);
  nodeSprite.lineTo(xCoord+520,yCoord-130);
  
  // bottom links
  nodeSprite.moveTo(xCoord+width/2,yCoord+height*2+space_v);
  nodeSprite.lineTo(xCoord+width/2,yCoord+height*2+space_v+40);
  nodeSprite.lineTo(xCoord+width+space_h/2,yCoord+height*2+space_v+40);

  nodeSprite.moveTo(xCoord+width*3/2+space_h,yCoord+height*2+space_v);
  nodeSprite.lineTo(xCoord+width*3/2+space_h,yCoord+height*2+space_v+40);
  nodeSprite.lineTo(xCoord+width+space_h/2,yCoord+height*2+space_v+40);
  nodeSprite.lineTo(xCoord+width+space_h/2,yCoord+height*2+space_v+60);
  nodeSprite.lineTo(xCoord+520,yCoord+height*2+space_v+60);

  // switches (static) -----------------------
  /*nodeSprite.moveTo(xCoord+width/2,yCoord-60);
  nodeSprite.lineTo(xCoord+width/2,yCoord-90);
  nodeSprite.drawCircle(xCoord+width/2,yCoord-60,3)
  nodeSprite.drawCircle(xCoord+width/2,yCoord-90,3)

  nodeSprite.moveTo(xCoord+width*3/2+space_h,yCoord-60);
  nodeSprite.lineTo(xCoord+width*3/2+space_h,yCoord-90);
  nodeSprite.drawCircle(xCoord+width*3/2+space_h,yCoord-60,3)
  nodeSprite.drawCircle(xCoord+width*3/2+space_h,yCoord-90,3)

  nodeSprite.moveTo(xCoord+450,yCoord-130);
  nodeSprite.lineTo(xCoord+480,yCoord-130);
  nodeSprite.drawCircle(xCoord+450,yCoord-130,3)
  nodeSprite.drawCircle(xCoord+480,yCoord-130,3)*/


  nodeSprite.zIndex = NODE_ZIX;

  nodeSprite.interactive=interactive;
  nodeSprite.buttonMode=interactive;

  return nodeSprite;
}

// switches  -----------------------
export class SwitchSprite extends PIXI.Graphics{
  constructor(xCoord1,yCoord1,xCoord2,yCoord2,interactive_) {
    super();

    const interactive = interactive_ || false;

    this.switchObj = new PIXI.Graphics();    
    this.switchObj.zIndex = NODE_ZIX+10;
    this.switchObj.interactive=interactive;
    this.switchObj.buttonMode=interactive;

    

    this.openAction = () =>{
      const angOpen = Math.atan2((yCoord2-yCoord1),(xCoord2-xCoord1))-0.5;
      const dist = Math.sqrt(Math.pow((xCoord2-xCoord1),2)+Math.pow((yCoord2-yCoord1),2));
      this.switchObj.clear()
      this.switchObj.lineStyle(LINKS_WIDTH, BATT_COLOR_BORDER);
      this.switchObj.moveTo(xCoord1,yCoord1);
      this.switchObj.lineTo(xCoord1+dist*Math.cos(angOpen),yCoord1+dist*Math.sin(angOpen));
      this.switchObj.drawCircle(xCoord1,yCoord1,3)
      this.switchObj.drawCircle(xCoord2,yCoord2,3)
      this.addChild(this.switchObj);
    }
    
    this.closeAction = () => {
      this.switchObj.clear()
      this.switchObj.lineStyle(LINKS_WIDTH, BATT_COLOR_BORDER);
      this.switchObj.moveTo(xCoord1,yCoord1);
      this.switchObj.lineTo(xCoord2,yCoord2);
      this.switchObj.drawCircle(xCoord1,yCoord1,3)
      this.switchObj.drawCircle(xCoord2,yCoord2,3)
      this.addChild(this.switchObj);
    }

    this.closeAction();
  }

  updateSwitchState(state) {
    
    if(state)
      this.openAction();
    else
      this.closeAction();
    
  }

}

//alert icon

export class AlertSprite extends PIXI.Graphics{
  constructor(xCoord,yCoord,width,height,interactive_) {
    super();

    const interactive = interactive_ || false;

    this.alert = PIXI.Sprite.from(require(`../assets/objects/alert.svg`));
  
    this.alert.width = width;
    this.alert.height = height;
    this.alert.x = xCoord;
    this.alert.y = yCoord;

    
    this.alert.zIndex = NODE_ZIX+100;
    this.alert.interactive=interactive;
    this.alert.buttonMode=interactive;
    
    this.container = new PIXI.Container();
    this.addChild(this.container);
    this.container.addChild(this.alert);

    
    const blinkingAnimation = new PIXI.Ticker();
    this.step=0.1;

    blinkingAnimation.add(() => {
      if (this.container.alpha>1) {
        this.step=-Math.abs(this.step);
      } else if(this.container.alpha<0){
        this.step = Math.abs(this.step);
      }
      this.container.alpha=this.container.alpha+this.step;
    })
   


    this.blinkAction = () =>{
      this.alert.visible=true;
      if(!blinkingAnimation.started)
        blinkingAnimation.start();
    }
    
    this.normalAction = () =>{
      this.alert.visible=false;
      blinkingAnimation.stop();
    }
    
    this.normalAction();

  }

  updateSwitchState(state) {
    
    if(state)
      this.blinkAction();
    else
      this.normalAction();
    
  }

  

}

// kpi
export class KpiWindow_batt extends PIXI.Graphics{
  constructor(xPos, yPos) {
    super();
    const width = 1300;
    const height = 500;

    this.lineStyle(KPI_BORDERWIDTH, KPI_BORDERCOLOR);
    //this.beginFill(0xffffff, 0.7);
    this.drawRect(0, 0,width, height);
    this.position.set(xPos+5, yPos+5);
    this.zIndex = KPI_ZIX;

    const mask = new PIXI.Graphics();
    // Add the rectangular area to show
    mask.drawRect(0, 0,width, height);
    mask.endFill();

    // Add container that will hold our masked content
    const maskContainer = new PIXI.Container(); // Set the mask to use our graphics object from above
    maskContainer.mask = mask;        // Add the mask as a child, so that the mask is positioned relative to its parent
    maskContainer.addChild(mask);     // Offset by the window's frame width
    maskContainer.position.set(0,0);  // And add the container to the window!
    this.addChild(maskContainer);


    // box info
    this.lineStyle(KPI_BORDERWIDTH,BATT_COLOR_BORDER,0.8);
    this.drawRect(850, 20,550, 450);

    const textlineHeight = 25;
    const textlineHeightBox = 35;

    const kpiValueStyle = new PIXI.TextStyle({
      fontFamily: KPI_TEXT_FONTNAME,
      fontSize: 20,
      fontWeight: KPI_VALUES_FONTWEIGHT,
      fill:  0x000000,
    });
    const tittleStyle = new PIXI.TextStyle({
      fontFamily: KPI_TEXT_FONTNAME,
      fontSize: 20,
      fontWeight: KPI_VALUES_FONTWEIGHT,
      fill:  BATT_COLOR_BORDER,
    });

    this.sigValues = { //array of text controls for sig values
      // battery
      ssm_902_A: new PIXI.Text( 'NaN A', kpiValueStyle),
      ssm_902_V: new PIXI.Text( 'NaN V', kpiValueStyle),
      // string 1
      ssm_904_1_A: new PIXI.Text( 'NaN A', kpiValueStyle),
      ssm_904_1_V: new PIXI.Text( 'NaN V', kpiValueStyle),
      ssm_904_1_SoC: new PIXI.Text( 'NaN %', kpiValueStyle),
      //string 2
      ssm_904_2_A: new PIXI.Text( 'NaN A', kpiValueStyle),
      ssm_904_2_V: new PIXI.Text( 'NaN V', kpiValueStyle),
      ssm_904_2_SoC: new PIXI.Text( 'NaN %', kpiValueStyle),
      //module 11
      ssm_904_sm_1_1_ModCellTmpAvg: new PIXI.Text( 'NaN ºC', kpiValueStyle),
      ssm_905_1_1_V: new PIXI.Text( 'NaN V', kpiValueStyle),
      //module 12
      ssm_904_sm_1_2_ModCellTmpAvg: new PIXI.Text( 'NaN ºC', kpiValueStyle),
      ssm_905_1_2_V: new PIXI.Text( 'NaN V', kpiValueStyle),
      //module 21
      ssm_904_sm_2_1_ModCellTmpAvg: new PIXI.Text( 'NaN ºC', kpiValueStyle),
      ssm_905_2_1_V: new PIXI.Text( 'NaN V', kpiValueStyle),
      //module 22
      ssm_904_sm_2_2_ModCellTmpAvg: new PIXI.Text( 'NaN ºC', kpiValueStyle),
      ssm_905_2_2_V: new PIXI.Text( 'NaN V', kpiValueStyle),

    };


    this.sigValues.ssm_902_A.setTransform(500, 40);
    this.sigValues.ssm_902_V.setTransform(500, 40+textlineHeight);

    this.sigValues.ssm_904_1_A.setTransform(170, 120);
    this.sigValues.ssm_904_1_V.setTransform(170, 120+textlineHeight);
    this.sigValues.ssm_904_1_SoC.setTransform(170, 120+2*textlineHeight);

    this.sigValues.ssm_904_2_A.setTransform(390, 120);
    this.sigValues.ssm_904_2_V.setTransform(390, 120+textlineHeight);
    this.sigValues.ssm_904_2_SoC.setTransform(390, 120+2*textlineHeight);

    this.sigValues.ssm_904_sm_1_1_ModCellTmpAvg.setTransform(210, 210);
    this.sigValues.ssm_905_1_1_V.setTransform(210, 210+textlineHeight);
    this.sigValues.ssm_904_sm_1_2_ModCellTmpAvg.setTransform(210, 300);
    this.sigValues.ssm_905_1_2_V.setTransform(210, 300+textlineHeight);
    this.sigValues.ssm_904_sm_2_1_ModCellTmpAvg.setTransform(420, 210);
    this.sigValues.ssm_905_2_1_V.setTransform(420, 210+textlineHeight);
    this.sigValues.ssm_904_sm_2_2_ModCellTmpAvg.setTransform(420, 300);
    this.sigValues.ssm_905_2_2_V.setTransform(420, 300+textlineHeight);


    maskContainer.addChild(this.sigValues.ssm_902_A);
    maskContainer.addChild(this.sigValues.ssm_902_V);

    maskContainer.addChild(this.sigValues.ssm_904_1_A);
    maskContainer.addChild(this.sigValues.ssm_904_1_V);
    maskContainer.addChild(this.sigValues.ssm_904_1_SoC);

    maskContainer.addChild(this.sigValues.ssm_904_2_A);
    maskContainer.addChild(this.sigValues.ssm_904_2_V);
    maskContainer.addChild(this.sigValues.ssm_904_2_SoC);

    maskContainer.addChild(this.sigValues.ssm_904_sm_1_1_ModCellTmpAvg);
    maskContainer.addChild(this.sigValues.ssm_905_1_1_V);
    maskContainer.addChild(this.sigValues.ssm_904_sm_1_2_ModCellTmpAvg);
    maskContainer.addChild(this.sigValues.ssm_905_1_2_V);
    maskContainer.addChild(this.sigValues.ssm_904_sm_2_1_ModCellTmpAvg);
    maskContainer.addChild(this.sigValues.ssm_905_2_1_V);
    maskContainer.addChild(this.sigValues.ssm_904_sm_2_2_ModCellTmpAvg);
    maskContainer.addChild(this.sigValues.ssm_905_2_2_V);


    //Box
    this.sigValuesBox={
      ssm_902_State :  new PIXI.Text( '', kpiValueStyle),
      ssm_902_A :  new PIXI.Text( 'NaN A', kpiValueStyle),
      ssm_902_V :  new PIXI.Text( 'NaN V', kpiValueStyle),
      ssm_902_SoC :  new PIXI.Text( 'NaN %', kpiValueStyle),
      SoF :  new PIXI.Text( 'NaN A', kpiValueStyle)
    };
  
    this.sigCaptionBox={
      ssm_902_State: new PIXI.Text( 'System Status', tittleStyle),
      ssm_902_A :  new PIXI.Text( 'Total Current:', kpiValueStyle),
      ssm_902_V :  new PIXI.Text( 'Total Voltage:', kpiValueStyle),
      ssm_902_SoC :  new PIXI.Text( 'SoC:', kpiValueStyle),
      SoF :  new PIXI.Text( 'SoF:', kpiValueStyle)}

    this.sigValuesBox.ssm_902_State.setTransform(1050, 80);
    this.sigValuesBox.ssm_902_A.setTransform(1050, 80+textlineHeightBox);
    this.sigValuesBox.ssm_902_V.setTransform(1050, 80+2*textlineHeightBox);
    this.sigValuesBox.ssm_902_SoC.setTransform(1050, 80+3*textlineHeightBox);
    this.sigValuesBox.SoF.setTransform(1050, 80+4*textlineHeightBox);

    maskContainer.addChild(this.sigValuesBox.ssm_902_State);
    maskContainer.addChild(this.sigValuesBox.ssm_902_A);
    maskContainer.addChild(this.sigValuesBox.ssm_902_V);
    maskContainer.addChild(this.sigValuesBox.ssm_902_SoC);
    maskContainer.addChild(this.sigValuesBox.SoF);
 
    this.sigCaptionBox.ssm_902_State.setTransform(900, 80);  
    this.sigCaptionBox.ssm_902_A.setTransform(900, 80+textlineHeightBox);
    this.sigCaptionBox.ssm_902_V.setTransform(900, 80+2*textlineHeightBox);
    this.sigCaptionBox.ssm_902_SoC.setTransform(900, 80+3*textlineHeightBox);
    this.sigCaptionBox.SoF.setTransform(900, 80+4*textlineHeightBox);

    maskContainer.addChild(this.sigCaptionBox.ssm_902_State);
    maskContainer.addChild(this.sigCaptionBox.ssm_902_A);
    maskContainer.addChild(this.sigCaptionBox.ssm_902_V);
    maskContainer.addChild(this.sigCaptionBox.ssm_902_SoC);
    maskContainer.addChild(this.sigCaptionBox.SoF);


    /** @type {Map<number, PIXI.Text} */
    this.nodeSignalValObjs = new Map ();

    /**
     * format a signal sample current value for visual printing 
     * @param {SignalSample} signalSample 
     * @returns {string}
     */
    this.formatSigSample = (signalSample) => {
      if(!signalSample.units) return this.formatSigValue(signalSample);
      return `${this.formatSigValue(signalSample)} ${signalSample.units.substring(0,5)}`
    }

    /**
     * format signal values for visual printing
     * @param {SignalSample} signalSample 
     * @returns {string|number}
     */
    this.formatSigValue = (signalSample) => {
      if(signalSample.currentValue==null) return '-'
      if(typeof(signalSample.currentValue)=='string') return signalSample.currentValue.substring(0,8);
      if(typeof(signalSample.currentValue)=='number'){
        if(Math.abs(signalSample.currentValue)>1000) return Math.round(signalSample.currentValue);
        if(Math.abs(signalSample.currentValue)>100) return Math.round(signalSample.currentValue*10)/10;
        return Math.round(signalSample.currentValue*100)/100;
      }
      if(typeof(signalSample.currentValue)=='boolean') return signalSample.currentValue? 'on':'off';
      return '#'
    }

  }


  /**
     * register signals to the node for future updates
     * @param {SignalReg[]} arrSignals 
     * @returns {void}
     */
   setKpiSignals(arrSignals){
    
    const sigNameCounts = new Map();
    for(const sProps of arrSignals){ //check signal names to count name collisions
      const n = sigNameCounts.get(sProps.name)||0;
      sigNameCounts.set(sProps.name, n+1);
    }
    
    const signal_names = ['ssm_902_A','ssm_902_V',
    'ssm_904_1_A','ssm_904_1_V','ssm_904_1_SoC','ssm_904_2_A','ssm_904_2_V','ssm_904_2_SoC',
    'ssm_904_sm_1_1_ModCellTmpAvg','ssm_905_1_1_V','ssm_904_sm_1_2_ModCellTmpAvg','ssm_905_1_2_V',
    'ssm_904_sm_2_1_ModCellTmpAvg','ssm_905_2_1_V','ssm_904_sm_2_2_ModCellTmpAvg','ssm_905_2_2_V',];
    const signalBox_names = ['ssm_902_State','ssm_902_A','ssm_902_V','ssm_902_SoC','SoF'];
    //const signals = arrSignals.filter(p=> signal_names.includes(p.name))
    //const signalsBox = arrSignals.filter(p=> signalBox_names.includes(p.name))
    
    for(const sig of arrSignals){
    
      if(signalBox_names.includes(sig.name) && !signal_names.includes(sig.name)){
        this.nodeSignalValObjs.set(sig.signalId, [this.sigValuesBox[sig.name]])
      }else if(signal_names.includes(sig.name) && !signalBox_names.includes(sig.name)){
        this.nodeSignalValObjs.set(sig.signalId, [this.sigValues[sig.name]]);
      }else if(signalBox_names.includes(sig.name) && signal_names.includes(sig.name)){
        this.nodeSignalValObjs.set(sig.signalId,[this.sigValues[sig.name],this.sigValuesBox[sig.name]]);
      }
      
      if(sig.staticValue) this.updateKpiValues([{ signalId: sig.signalId, units: sig.units, currentValue: sig.staticValue }]);
    }
    
  }

  /**
     * updates kpi values in graphic controls for an array of signal samples 
     * @param {SignalSample[]} signalValues
     */
  updateKpiValues(signalValues) {
    
     
    /*if(sig.name=='ssm_902_State'){
      this.nodeSignalValObjs.set(sig.signalId, [this.sigValuesBox[sig.name]])
    }*/
    const states=['DISCONNECTED','INITIALIZING','CONNECTED','STANDBY','SOC PROTECTION','SUSPENDING','FAULT'];
    if(!signalValues.length) return ;
    for(const sig of signalValues){
      const txtCtrl = this.nodeSignalValObjs.get(sig.signalId);
      if(txtCtrl){
        for(const txt of txtCtrl){ 
          if(sig.name=='ssm_902_State')  {
            txt.text = states[sig.currentValue-1]
          } else{
            txt.text = this.formatSigSample(sig)
          }
          
        }
      }
    }
  }
}

export const getButtonSprite = (xCoord,yCoord,interactive_) => {
  const nodeSprite =  new PIXI.Graphics();
  const interactive = interactive_ || false;

  const width = 180;
  const height = 40;
  

  nodeSprite.lineStyle(2, 0xBDC3C7 ); // draw a circle, set the lineStyle to zero so the circle doesn't have an outline
  nodeSprite.beginFill(BATT_COLOR_FILL);
  nodeSprite.drawRect(xCoord, yCoord, width, height);
  nodeSprite.endFill();

  nodeSprite.zIndex = NODE_ZIX;

  nodeSprite.interactive=interactive;
  nodeSprite.buttonMode=interactive;

  return nodeSprite;
}

export const getTextSprite = (text,xCoord,yCoord,interactive_) => {

  const interactive = interactive_ || false;
  const tittleStyle = new PIXI.TextStyle({
    fontFamily: 'Helvetica',
    fontSize: 17,
    fontWeight:500,
  });

  
  const textSprite = new PIXI.Text(text, tittleStyle);
  textSprite.setTransform(xCoord+25,yCoord+10); 

  textSprite.zIndex = NODE_ZIX+1;

  textSprite.interactive=interactive;
  textSprite.buttonMode=interactive;

  return textSprite; 
}